import React, { useEffect, useRef, useState } from 'react';
import { Location } from '@arema/components/Classes';
import { Dropdown } from 'react-frontier2';
import { useTranslation } from 'react-i18next';
import { formatPlacesComponents } from '@arema/components/Util'

interface PlacesSearchProps{
	label?: string,
	placeholder?: string,
	comment?: string,
	style?: React.CSSProperties,
	options?: any,
	onLocation?: (location: Location)=>void,
}

interface PredictionResults{
	description: string,
	place_id: string,
	structured_formatting: {
		main_text: string,
		secondary_text: string,
	},
	matched_substrings: {
		offset: number,
		length: number,
	}[],
}

interface PlaceResult{

}

type PredictionResultStatus = 'INVALID_REQUEST' | 'NOT_FOUND' | 'OK' | 'OVER_QUERY_LIMIT' | 'REQUEST_DENIED' | 'UNKNOWN_ERROR' | 'ZERO_RESULTS';

var PlacesSearch = (props: PlacesSearchProps)=>{
	var { t } = useTranslation();
	var [loading, setLoading] = useState<boolean>(false);
	var autocomplete = useRef<{
		getQueryPredictions: (opt: { input: string }, cb: (r: PredictionResults[], status: PredictionResultStatus)=>void)=>void,
	}>(null);
	var places = useRef<{
		getDetails: (opts: { placeId: string }, cb: (r: PlaceResult, status: PredictionResultStatus)=>void)=>void
	}>(null);


	useEffect(()=>{
		var new_elem = document.createElement('div');
		setTimeout(()=>{
			(window as any).google.maps.importLibrary('places').then((lib: any)=>{
				autocomplete.current = new lib.AutocompleteService();
				places.current = new lib.PlacesService(new_elem);
			});
		}, 1000);
		return ()=>{
			new_elem.remove();
		}
	}, []);

	var getPredictions = (v: string) : Promise<PredictionResults[]>=>{
		return new Promise((resolve, reject)=>{
			if(!autocomplete.current) return reject('No service');
			autocomplete.current.getQueryPredictions({
				input: v,
				languageCode: 'es',
				...props.options,
			}, (res, status)=>{
				if(status!=='OK' && status!=='ZERO_RESULTS' && status!=='NOT_FOUND') return reject('Invalid status');
				return resolve(res || []);
			});
		})
	}

	var getResult = (place_id: string) : Promise<Location>=>{
		return new Promise((resolve, reject)=>{
			if(!places.current) return reject('No service');
			setLoading(true);
			places.current.getDetails({ placeId: place_id }, (res, status)=>{
				setLoading(false);
				if(status!=='OK') return reject('Invalid status');
				return resolve(formatPlacesComponents(res))
			});
		});
	}

	return <Dropdown
		value={null}
		label={props.label}
		placeholder={props.placeholder}
		comment={props.comment}
		style={props.style}
		loading={loading}
		onValueChange={v=>{
			if(!v || !props.onLocation) return;
			getResult(v).then(loc=>{
				return props.onLocation(loc);
			}).catch(err=>{
				console.log(err);
			})
		}}
		onAsyncSearch={async v=>{
			try{
				var pred = await getPredictions(v);
			}catch(e){
				return { error: t('common.unexpected_code', { code: 'LCL-GGLACP-1' }), items: [] };
			}
			return {
				error: null,
				items: pred.map(a=>({
					text: <>
						<div style={{ fontWeight: 'bold', lineHeight: '16px' }}>{a.structured_formatting.main_text}</div>
						<div style={{ fontSize: 12, color: 'gray', lineHeight: '12px' }}>{a.structured_formatting.secondary_text}</div>
					</>,
					value: a.place_id,
				})),
			};
		}}
	/>
	
	// return <Input
	// 	loading={isPlacePredictionsLoading}
	// 	onChange={}
	// />
}

export default PlacesSearch;